import React from "react"

interface Props {
	size?: number
}

export default function StripeIcon({size = 42}: Props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width={size} height={size} aria-label="Stripe">
			<path d="M474.9 416c0-28.2 23-38.4 61.2-38.4 54.6 0 123.6 16.5 178.2 45.9V256.1c-60-25.8-119.4-35.7-178.2-35.7-145.8 0-242.7 76.2-242.7 203.4 0 198.3 272.7 166.5 272.7 252 0 33.3-29 43.8-69.6 43.8-60.3 0-137.4-24.9-198.3-58.5v168c65.1 27.9 131.1 39.6 198.3 39.6 151.2 0 255.3-75 255.3-204-0.3-214.2-274.9-175.5-276.9-248.7z" />
		</svg>
	)
}
